<template>
  <div class="game_details">
    <div class="game_details_inner">
      <breadcrumb :link-list="breadcrumbList"></breadcrumb>
      <div class="details">
      <div class="details_info">
        <div class="DI_base_img">
          <div slot="reference">
            <el-skeleton :loading="loading" animated>
              <template slot="template">
                <el-skeleton-item
                  variant="image"
                  style="width: 420px; height: 420px;border-radius: 4px"
                />
              </template>
              <template>
                <el-image
                  style="width: 420px; height: 420px;border-radius: 4px"
                  :src="accountInfo.image"
                  fit="contain"
                  :preview-src-list="srcList">
                  <div slot="placeholder" class="image-slot">
                    图片加载中<span class="dot">...</span>
                  </div>
                </el-image>
              </template>
            </el-skeleton>
          </div>
        </div>
        <div class="DI_base_content">
          <el-skeleton :loading="loading" animated>
            <template slot="template">
              <div class="DI_product_title" >
                <div>
                  <el-skeleton-item variant="text" style="width:80px;margin: 0 10px 0 0"/>
                  <el-skeleton-item variant="text" style="width:300px"/>
                </div>
                <div style="display: flex;align-items: center">
                  <el-skeleton-item variant="text"
                                    style="width: 105px;height: 40px;border-radius: 4px;margin: 0 0 0 10px"
                                    v-for="index in 2" :key="index"/>
                </div>
              </div>
            </template>
            <template>
              <div class="DI_product_title">
                <div class="DIP_title">
                  <div class="DIP_title_top">
                    <span>{{ accountInfo.game_name }}</span>
                    {{ accountInfo.name }}
                  </div>
                </div>
                <div class="DIP_btn">
                  <div class="collect">
                    <div v-if="!accountInfo.is_collect" @click="collectClick" class="collectBtn"
                         @mouseenter="collectBtn = true" @mouseleave="collectBtn=false">
                      <img v-show="!collectBtn" src="@/assets/image/AllGame/collect.png" alt="">
                      <img v-show="collectBtn" src="@/assets/image/AllGame/collectHover.png" alt="">
                      收藏
                    </div>
                    <div v-else @click="collectClick" class="isCollectBtn">
                      <img src="@/assets/image/AllGame/isCollect.png" alt="">
                      已收藏
                    </div>

                    <div v-if="!can_bargain && accountInfo.is_show_bargain===1" @click.stop="seeking_price_cuts_confirm" class="priceCutBtn" @mouseenter="priceCutBtn = true"
                         @mouseleave="priceCutBtn=false">
                      <img v-show="!priceCutBtn" src="@/assets/image/AllGame/priceCut.png" alt="">
                      <img v-show="priceCutBtn" src="@/assets/image/AllGame/priceCutHover.png" alt="">
                      求降价
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-skeleton>
          <el-skeleton :loading="loading" animated>
            <template slot="template">
              <div class="DI_prodct_price"
                   style="display: flex;flex-direction: row;justify-content: space-between;width: 640px">
                <el-skeleton-item variant="text" style="width:250px"/>
                <el-skeleton-item variant="text" style="width:70px"/>
              </div>
            </template>
            <template>
              <div class="DI_prodct_price">
                <div id="DI_prodct_price">
                  商品价格：
                  <div>¥{{ accountInfo.sell_price }}</div>
                </div>
                <div id="DI_prodct_hot">
                  <img src="@/assets/image/Home/topGamesIco.png" alt="">
                  <span>{{ accountInfo.click }}</span>
                </div>
              </div>
            </template>
          </el-skeleton>
          <el-skeleton :loading="loading"  animated>
            <template slot="template">
              <div class="DI_prodct_zone">
                <el-skeleton-item style="width: 40%;margin: 0 50px 10px 0" variant="h3" v-for="index in 4" animated
                                  :key="index"/>
              </div>
            </template>
            <template>
              <div class="DI_prodct_zone">
                <div v-for="(categoryItem,index) in accountInfo.category" :key="index" id="DI_prodct_zone">
                  <div class="zone_title">
                    {{ categoryItem.name }}：
                  </div>
                  <div class="zone_content">{{ categoryItem.value }}</div>
                </div>
              </div>
            </template>
          </el-skeleton>
          <el-skeleton :loading="loading"  animated>
            <template slot="template">
              <div class="DI_prodct_addDate">
                <el-skeleton-item variant="text" style="width:70px"/>
                <el-skeleton-item variant="text" style="width:250px"/>
              </div>
            </template>
            <template>
              <div class="DI_prodct_addDate">
                <div>
                  库存：
                  <span>{{ accountInfo.num }}</span>
                </div>
                <div>
                  上架时间：
                  <span>{{ accountInfo.up_time|moment }}</span>
                </div>
              </div>
            </template>
          </el-skeleton>
          <el-skeleton :loading="loading"  animated>
            <template slot="template">
              <div class="DI_btnGroup">
                <el-skeleton-item variant="button" style="width:190px;height: 40px"/>
                <el-skeleton-item variant="button" style="width:220px;height: 60px;margin: 0 0 0 10px" v-for="index in 2" :key="index"/>
              </div>
            </template>
            <template>
              <div class="DI_btnGroup">
                <div class="DIBG_buyNum">
                  购买数量：
                  <el-input-number v-model="num" :min="1" :max="accountInfo.num" label="描述文字"></el-input-number>
                </div>
                <a target="_blank" @click="historySerAdd('buy')" class="onlineDealBtn">立即购买</a>
                <a class="cusSerBtn" target="_blank" @click="historySerAdd">
                  <div>咨询客服</div>
                </a>
                <!--        <router-link :to="{name:'OnlineDeal',query:{id:id,game_id:game_id}}" class="onlineDealBtn">立即购买</router-link>-->
              </div>
            </template>
          </el-skeleton>
        </div>
      </div>
      <div class="DI_productName">
        <el-skeleton :loading="loading"  animated>
          <template slot="template">
            <div class="DI-productName">
              <el-skeleton-item variant="text" style="width:110px;margin: 0 0 10px"/>
              <el-skeleton-item variant="text" style="width:100%" v-for="index in 2" :key="index"/>
            </div>
          </template>
          <template>
            <div class="DI-productName">
              <div class="DI_productName_title">
                <img src="@/assets/image/PersonalCenter/MyAccount/contentItemTitle.png" alt="">
                商品描述
              </div>
              <div class="DI_productName_text">
                {{ accountInfo.content }}
              </div>
            </div>
          </template>
        </el-skeleton>
      </div>
      <div class="details_tabbar">
        <el-skeleton :loading="loading"  animated>
          <template slot="template">
            <div>
              <div style="display: flex;align-items: center">
                <el-skeleton-item variant="button" style="width:10%;margin: 0 10px 0 0" v-for="index in 4" :key="index"/>
              </div>
              <div style="padding: 20px 0">
                <el-skeleton-item variant="image" style="width: 100%;height:300px;margin: 0 0 10px" v-for="index in 3" :key="index"/>
              </div>
            </div>

          </template>
          <template>
            <el-tabs v-model="activeName">
              <el-tab-pane label="装备详情" name="first">
                <div class="third_content">
                  <div v-if="game_id == '10'" class="Tip">
                    <img src="@/assets/image/AllGame/JL_tip.png" alt="" class="JL_tip">
                    <img src="@/assets/image/AllGame/JL_tipBtn.png" alt="" class="JL_tipBtn"
                         @click="gotoLink('https://jq.qq.com/?_wv=1027&k=bpmHpZUb')">
                  </div>
                  <div v-html="accountInfo.c_data"></div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="交易须知" name="second">
                <div class="third_content">
                  <div v-html="accountInfo.game_notice"></div>
                </div>
              </el-tab-pane>
              <template v-if="game_id != 13">
                <el-tab-pane label="交易流程" name="third">
                  <div class="third_content">
                    <img src="@/assets/image/AllGame/equipProcess.png" alt="">
                    <!--              <div v-html="accountInfo.game_introduce"></div>-->
                  </div>
                </el-tab-pane>
                <el-tab-pane label="业务介绍" name="fourth">
                  <div class="third_content">
                    <div v-html="accountInfo.game_introduce"></div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="交易群" name="fivth">
                  <div class="fourth_content" v-if="qqGrounp && qqGrounp.length">
                    <div class="fourth_content_item" v-for="(item,index) in qqGrounp" :key="index">
                      <div class="fourth_content_item_box">
                        <div>
                          <img src="@/assets/image/AllGame/contentItemTitle.png" alt="">
                        </div>
                        <div class="qq_logo">
                          <img src="@/assets/image/AllGame/QQlogo.png" alt="">
                        </div>
                        <div class="group_name">{{ item.name }}</div>
                        <a class="add_group" target="_blank" :href="item.link">点击加群</a>
                      </div>
                    </div>
                  </div>
                  <div class="groupEmpty" v-else>
                    <empty-state
                      title="暂无可加入交易群"
                      description="您可以先咨询客服获取最新社群信息"
                      icon="el-icon-chat-dot-round"
                      icon-size="52"
                    ></empty-state>
                  </div>
                </el-tab-pane>
              </template>
            </el-tabs>
          </template>
        </el-skeleton>

      </div>
      </div>
    </div>
    <myDialog :text="'尊敬的游严选VIP您好，根据相关法律法规要求，需实名认证方可进行购买。'" :btn-text="'去实名'" btn :show="realNameShow"
              :close-fun="mydialogClose" :btn-fuc="mydialogBtnClick"
    ></myDialog>
  </div>
</template>

<script>
import {
  apiEquipInfo,
  apiCollectEquip,
  apiBargainAddEquip,
  apiBargainAdd,
  apiBargainClcik,
  apiHistoryProductAdd, apiHistoryCusAdd, apiuserInfo, apiGameInfo
} from "@/request/API";
import myDialog from "@/components/myDialog";
import breadcrumb from "@/components/breadcrumb";
import EmptyState from "@/components/emptyState";

export default {
  name: '',
  components: {
    myDialog,
    breadcrumb,
    EmptyState
  },
  data() {
    return {
      //游戏名称
      game_name: '',
      //游戏id
      game_id: this.$route.query.game_id,
      //账号id
      id: this.$route.query.id,
      // 当前选中tabbar
      activeName: 'first',
      // 交易qq群
      qqGrounp: [],
      //账号详情
      accountInfo: {
        image: ''
      },
      //购买数量
      num: '',
      can_show: true,
      srcList: [],
      collectBtn: false,
      priceCutBtn: false,
      //立即购买 实名弹窗
      realNameShow: false,
      // 是否53客服/游严选客服
      sys_service_type: 0,
      loading: true,
      msg:{},
      can_bargain:'',
      // 面包屑
      breadcrumbList: [
        {name: '全部游戏', link: '/allGame'},
        {name: '', link: '/selectgame', query: {game_id: this.$route.query.game_id}},
        {name: '装备道具', link: '/selectgame', query: {game_id: this.$route.query.game_id}},
        {name: '装备详情'}
      ]
    }
  },
  methods: {
    /**
     * @description: 跳转联系客服
     * @return {*}
     */
    cusSerBtnClick() {
      this.$accessLink(this.accountInfo.game_customer);
      window.open(`${this.accountInfo.game_customer}?u_cust_id=${this.$store.state.userData.user_id}&u_cust_name=${this.$store.state.userData.nickname}`, '_blank')
    },
    /**
     * 收藏按钮
     */
    collectClick() {
      if (this.$store.state.loginStatus) {
        apiCollectEquip({
          game_id: this.game_id,
          acc_id: this.id,
        }).then(res => {
          this.accountInfo.is_collect = res.data.is_collect
        }).catch(err => {
          this.$message({
            type: "error",
            center: true,
            message: err.msg
          })
        })
      } else {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id,
          },
        })
      }
    },
    seeking_price_cuts_confirm() {
      // apiBargainClcik({
      //   game_id:this.game_id,
      //   id:this.id,
      // }).catch(err=>{
      //   this.$message({
      //     type:"error",
      //     message:err.msg,
      //     center:true
      //   })
      // })
      if (this.$store.state.loginStatus) {
        let sell_price = 'block'
        if (this.accountInfo.sell_price == '0.00') {
          sell_price = 'none'
        }
        const h = this.$createElement;
        if (this.accountInfo.is_bargain) {
          this.$msgbox({
            title: '',
            message: h('div', {class: 'confirm_content'}, [
              h('div', {class: 'confirm_original_price'}, '原价：' + this.accountInfo.sell_price + ''),
              h('div', {class: 'confirm_my_bid'}, '我的出价：' + this.accountInfo.bargain_price + ''),
              h('div', {
                class: 'confirm_my_bid',
                style: "display:" + sell_price + ""
              }, '卖家最低报价：' + `${this.accountInfo.sell_bargain_price == 0 ? this.accountInfo.sell_price : this.accountInfo.sell_bargain_price}` + ''),
              h('div', {class: 'confirm_modify_bid'}, [
                h('div', {class: 'confirm_modify_bid_text'}, '修改出价：'),
                h('input', {
                  class: 'confirm_modify_bid_input',
                  attrs: {placeholder: "输入修改后的价格", id: "confirm_modify_bid_input"}
                }),
              ]),
              h('div', {class: 'confirm_modify_bid_tips'}, '（提示：24小时内只能求降价1次）'),
            ]),
            confirmButtonText: '确认修改',
            confirmButtonClass: 'change_price_confirm_btn',
            customClass: 'change_price_confirm',
            closeOnClickModal: false,
            showClose: true,
            callback: action => {
              if (action === "confirm") {
                apiBargainAddEquip({
                  id: this.accountInfo.bargain_id,
                  price: document.getElementById("confirm_modify_bid_input").value
                }).then(res => {
                  this.$message({
                    message: "修改成功",
                    center: true,
                    type: 'success'
                  })
                }).catch(err => {
                  this.$message({
                    message: err.msg,
                    center: true,
                    type: 'error'
                  })
                })
              }
              document.getElementById("confirm_modify_bid_input").value = ''
            }
          });
        } else {
          this.$msgbox({
            title: '',
            message: h('div', {class: 'confirm_content'}, [
              h('div', {class: 'confirm_original_price'}, '原价：' + this.accountInfo.sell_price + ''),
              h('div', {class: 'confirm_modify_bid'}, [
                h('div', {class: 'confirm_modify_bid_text'}, '我的出价：'),
                h('input', {
                  class: 'confirm_modify_bid_input',
                  attrs: {placeholder: "输入我出的价格", id: 'confirm_modify_bid_input'}
                }),
              ]),
              h('div', {class: 'confirm_modify_bid_tips'}, '（提示：24小时内只能求降价1次）'),
            ]),
            confirmButtonText: '确认发起',
            confirmButtonClass: 'change_price_confirm_btn',
            customClass: 'add_price_confirm',
            closeOnClickModal: false,
            showClose: true,
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                const price = document.getElementById("confirm_modify_bid_input").value
                if((price+'').includes('.')) {
                  this.$message({
                    type: "error",
                    message: '价格不支持小数',
                    center: true
                  })
                  return
                }
              }
              done()
            },
            callback: action => {
              if (action === "confirm") {
                apiBargainAddEquip({
                  game_id: this.game_id,
                  product_id: this.id,
                  price: document.getElementById("confirm_modify_bid_input").value
                }).then(res => {
                  this.$message({
                    center: true,
                    message: "发起降价请求成功",
                    type: 'success'
                  })
                  this.accountInfo.is_bargain = true
                  this.accountInfo.bargain_price = res.data.bargain_price

                }).catch(err => {
                  this.$message({
                    message: err.msg,
                    center: true,
                    type: 'error'
                  })
                })
              }
              document.getElementById("confirm_modify_bid_input").value = ''
            }
          });
        }
      } else {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id,
          },
        })
      }

    },
    //初始化数据
    async onLoad() {
      this.msg = this.$message({
        message: '页面加载中，请稍等～',
        type: 'info',
        duration:0
      })
      await apiEquipInfo({
        id: this.id,
      }).then(res => {
        this.can_show = res.data.can_show
        this.accountInfo = res.data
        this.srcList.push(res.data.image)
        this.game_name = res.data.game_name
        this.breadcrumbList[1].name = res.data.game_name
        this.qqGrounp = res.data.game_qun
        document.title = this.accountInfo.name
        this.loading = false
        this.msg.close()
      }).catch(err=>{
        this.msg = this.$message({
          message: '页面加载失败，请刷新页面',
          type: 'error',
          duration:0
        })
      })
    },
    /**
     * 跳转链接
     * @param link 链接
     */
    gotoLink(link) {
      window.open(link)
    },

    /**
     * 商品浏览记录添加
     */
    historyProductAdd() {
      apiHistoryProductAdd({
        game_id: this.game_id,
        product_id: this.id,
        product_type: 2
      })
    },
    /**
     * 商品客服咨询记录添加
     */
    async historySerAdd(type) {
      if (this.$store.state.loginStatus) {
        let userInfo = await apiuserInfo({action: 'verified'})
        if (
            (userInfo.data.cert_id === '' &&
            this.$store.state.systemInfo.real_name_auth == '1' &&
            this.$store.state.userData.country_code == '86') ||
            (userInfo.data.cert_id === '' &&
            this.$store.state.systemInfo.real_name_auth == '0' &&
            type == 'buy')
          ) {
          this.realNameShow = true
          return
        }
        apiHistoryCusAdd({
          game_id: this.game_id,
          product_id: this.id,
          product_type: 2
        })
        this.$customerShunt.getBuyOrGroupCode(this.id, this.game_id, 2, (data) => {
          this.$openIM({
            game_id: this.game_id,
            shopid: this.id,
            product_type: 2,
            gameAlias: data.group_code,
            im_type: 3
          })
        })
        // this.$openIM({
        //   game_id: this.game_id,
        //   shopid: this.id,
        //   product_id: this.id,
        //   product_type: 2
        // })

        // if (this.sys_service_type == 2) {
        //   let routeData = this.$router.resolve({
        //     name: 'chatRoom',
        //     query: {
        //       game_id: this.game_id,
        //       shopid: this.id,
        //       product_type: 2
        //     }
        //   })
        //   window.open(routeData.href, '_blank')
        // } else {
        //   this.cusSerBtnClick()
        // }
        // ${accountInfo.game_customer}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}
      } else {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id,
          },
        })
      }
    },

    /**
     * 关闭实名认证提示框
     */
    mydialogClose() {
      this.realNameShow = false
    },
    mydialogBtnClick() {
      this.$router.push({
        path: '/personalCenter/personalInfo/rNameAuthentication',
        query: {
          Rurl: this.$route.fullPath,
        },
      })
    },
  },
  mounted() {
    //初始化数据
    this.onLoad()
    this.historyProductAdd()
    apiGameInfo({
      id: this.game_id
    }).then(res => {
      // can_bargain 0 老求降价  1新求降价
      this.can_bargain = res.data.can_bargain
      this.sys_service_type = res.data.sys_service_type
    })
  },
  watch: {},
  computed: {},
  created() {
    document.title = ''
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'EquipmentDetails') {
      document.title = '游严选网络游戏账号交易代售平台-签署合同让交易享受法律保护'
      next()
    }
  }

}
</script>

<style lang="less">
.third_content img {
  max-width: 100%;
  object-fit: cover;
  background: #D8D8D8;
  border-radius: 4px;
  margin: 0 0 9px 0;
}

.add_price_confirm {
  width: 500px !important;
  height: 300px !important;
  background: var(--bg-card, #FFFFFF) !important;
  border-radius: 4px !important;
  padding: 0;
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

  .el-message-box__header > .el-message-box__title {
    display: none;
  }

  .el-message-box__header, .el-message-box__content {
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }

  .el-message-box__btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .el-message-box__title {
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5B5B5B;
    line-height: 28px;
  }

  .el-message-box__container {
    margin-top: 63px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 22px;
  }

  .change_price_confirm_btn {
    margin-top: 20px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 4px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }

  .change_price_confirm_btn:hover {
    background: var(--primary-hover, #E84A12) !important;
  }

  .confirm_content {
    display: flex;
    flex-direction: column;
  }

  .confirm_original_price {
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--primary, #FF5A1F);
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_my_bid {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_modify_bid {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .confirm_modify_bid_text {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
  }

  .confirm_modify_bid_input {
    width: 210px;
    height: 40px;
    background: #F9F9F9;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }

  .confirm_modify_bid_tips {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #BFBFBF;
    line-height: 22px;
    margin-left: 100px;
  }

  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }
}

.change_price_confirm {
  width: 500px !important;
  height: 320px !important;
  background: var(--bg-card, #FFFFFF) !important;
  border-radius: 4px !important;
  padding: 0;
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

  .el-message-box__header > .el-message-box__title {
    display: none;
  }

  .el-message-box__header, .el-message-box__content {
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }

  .el-message-box__btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .el-message-box__title {
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5B5B5B;
    line-height: 28px;
  }

  .el-message-box__container {
    margin-top: 34px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 22px;
  }

  .change_price_confirm_btn {
    margin-top: 20px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 4px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }

  .change_price_confirm_btn:hover {
    background: var(--primary-hover, #E84A12) !important;
  }

  .confirm_content {
    display: flex;
    flex-direction: column;
  }

  .confirm_original_price {
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--primary, #FF5A1F);
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_my_bid {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_modify_bid {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .confirm_modify_bid_text {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
  }

  .confirm_modify_bid_input {
    width: 210px;
    height: 40px;
    background: #F9F9F9;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }

  .confirm_modify_bid_tips {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #BFBFBF;
    line-height: 22px;
    margin-left: 100px;
  }

  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }
}
</style>

<style lang="less" scoped>
/deep/ .el-tabs__nav-wrap::after {
  content: none;
}

/deep/ .el-tabs__header {
  height: 64px;
  margin: 0;
  padding: 0 24px;
  border-bottom: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: none !important;
}

/deep/ .el-tabs__nav-scroll,
/deep/ .el-tabs__nav {
  height: 64px;
  display: flex;
  align-items: center;
}

/deep/ .el-tabs__item {
  height: 36px;
  padding: 0 18px !important;
  margin-right: 8px;
  border-radius: 4px;
  font-size: 15px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: var(--text-secondary, #5A5F6B);
  line-height: 36px;
  transition: color 0.2s ease, background-color 0.2s ease;
}

/deep/ .el-tabs__item:hover {
  color: var(--brand-blue, #1A1D24);
  background: var(--brand-blue-light, #F0EDE8);
}

/deep/ .el-tabs__item.is-active {
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: var(--brand-blue, #1A1D24);
  background: var(--brand-blue-light, #F0EDE8);
}

/deep/ .el-tabs__active-bar.is-top {
  height: 0;
}

.game_details {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding: 0 16px 32px;
  background: var(--bg-page, #F7F5F2);

  .game_details_inner {
    width: 1200px;
    max-width: 100%;
    box-sizing: border-box;
  }

  .details {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .details_info {
      min-height: 470px;
      box-sizing: border-box;
      padding: 24px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      display: flex;
      align-items: stretch;
      gap: 24px;

      .DI_base_img {
        flex: 0 0 420px;
        width: 420px;
        min-height: 420px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        overflow: hidden;

        /deep/ .el-image {
          display: block;
          background: var(--bg-section, #F7F5F2);
        }

        .image-slot {
          width: 420px;
          height: 420px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--text-muted, #9AA0AC);
          font-size: 14px;
        }
      }

      .DI_base_content {
        min-width: 0;
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        /deep/.DI_product_title {
          min-height: 76px;
          padding: 0;
          background: transparent;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          gap: 16px;

          .DIP_title {
            min-width: 0;
            flex: 1 1 auto;

            .DIP_title_top {
              font-size: 22px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--text-main, #111827);
              line-height: 32px;
              max-height: 64px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin: 0;

              span {
                display: inline-flex;
                max-width: 180px;
                height: 28px;
                padding: 0 12px;
                margin: 0 10px 0 0;
                align-items: center;
                vertical-align: 2px;
                background: var(--brand-blue-light, #F0EDE8);
                border: 1px solid rgba(26, 29, 36, 0.16);
                border-radius: 4px;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: var(--brand-blue, #1A1D24);
                line-height: 28px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }

          .DIP_btn {
            flex: 0 0 auto;

            .collect {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 10px;

              .collectBtn, .priceCutBtn {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 96px;
                height: 36px;
                border-radius: 4px;
                border: 1px solid rgba(26, 29, 36, 0.22);
                background: #FFFFFF;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: var(--brand-blue, #1A1D24);
                transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

                img {
                  width: 16px;
                  height: 16px;
                  margin: 0 5px 0 0;
                  object-fit: contain;
                }
              }

              .isCollectBtn {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 96px;
                height: 36px;
                border-radius: 4px;
                border: 1px solid rgba(26, 29, 36, 0.22);
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: #FFFFFF;
                background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));

                img {
                  width: 16px;
                  height: 16px;
                  margin: 0 5px 0 0;
                  object-fit: contain;
                }
              }

              .collectBtn:hover, .priceCutBtn:hover {
                background: var(--brand-blue-light, #F0EDE8);
                border-color: rgba(26, 29, 36, 0.45);
                box-shadow: 0 8px 18px rgba(26, 29, 36, 0.10);
              }
            }
          }
        }

        /deep/.DI_prodct_price {
          box-sizing: border-box;
          min-height: 76px;
          margin: 18px 0 0;
          padding: 14px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          background: linear-gradient(135deg, var(--primary-soft, #FFF3E7) 0%, #FFFFFF 100%);
          border: 1px solid rgba(255, 122, 26, 0.18);
          border-radius: 4px;

          #DI_prodct_price {
            display: flex;
            align-items: baseline;
            min-width: 0;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            margin: 0 10px 0 0;

            div {
              font-size: 30px;
              font-family: PingFang SC, PingFang SC-Semibold;
              font-weight: 600;
              color: var(--primary, #FF7A1A);
              margin: 0 0 0 10px;
              max-width: 320px;
              line-height: 36px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          #DI_prodct_hot {
            flex: 0 0 auto;
            min-width: 86px;
            height: 36px;
            padding: 0 12px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #FFFFFF;
            border: 1px solid rgba(26, 29, 36, 0.10);
            border-radius: 4px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: var(--brand-blue, #1A1D24);

            img {
              margin: 0 6px 0 0;
              width: 17.38px;
              height: 20px;
            }
          }
        }

        /deep/.DI_prodct_zone {
          min-height: 82px;
          display: flex;
          flex-wrap: wrap;
          gap: 10px 12px;
          margin: 18px 0 8px;
          padding: 0;

          #DI_prodct_zone {
            width: calc((100% - 12px) / 2);
            min-height: 36px;
            box-sizing: border-box;
            padding: 7px 10px;
            display: flex;
            align-items: center;
            margin: 0;
            background: var(--bg-section, #F7F5F2);
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;

            .zone_title {
              flex: 0 0 78px;
              font-size: 13px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-muted, #9AA0AC);
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .zone_content {
              min-width: 0;
              flex: 1 1 auto;
              font-size: 13px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-main, #111827);
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        /deep/.DI_prodct_promise {
          padding: 10px 0 11px 20px;
          border-top: 1px solid #F1F1F1;
          border-bottom: 1px solid #F1F1F1;
          display: flex;
          flex-direction: row;
          align-items: center;

          .promise_title {
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: #8F8F8F;
            line-height: 20px;
            margin: 0 16px 0 0;
          }

          .promise_list {
            display: flex;
            flex-direction: row;

            .promise_item {
              display: flex;
              flex-direction: row;
              align-items: center;
              font-size: 14px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 400;
              color: #BFBFBF;
              margin: 0 40px 0 0;

              img {
                margin: 0 4px 0 0;
              }
            }

            .promise_item:last-of-type {
              margin: 0;
            }
          }
        }

        /deep/.DI_prodct_addDate {
          display: flex;
          justify-content: space-between;
          gap: 16px;
          border-top: 1px solid var(--border-soft, #E8E4DE);
          border-bottom: 1px solid var(--border-soft, #E8E4DE);
          padding: 14px 0;
          margin: 8px 0 0;

          div {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            line-height: 22px;

            span {
              color: var(--text-main, #111827);
            }
          }
        }

        /deep/.DI_btnGroup {
          min-height: 52px;
          padding: 18px 0 0;
          display: flex;
          align-items: center;
          gap: 12px;

          div {
            cursor: pointer;
          }

          .cusSerBtn {
            flex: 0 0 140px;
            height: 52px;
            margin: 0;
            box-sizing: border-box;
            border-radius: 4px;
            border: 1px solid rgba(26, 29, 36, 0.22);
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--brand-blue-light, #F0EDE8);
            font-size: 18px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: var(--brand-blue, #1A1D24);
            cursor: pointer;
            transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

            .cusSerBtn_tip {
              font-size: 12px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);
            }
          }

          .cusSerBtn:hover {
            background: #FFFFFF;
            border-color: rgba(26, 29, 36, 0.45);
            box-shadow: 0 8px 18px rgba(26, 29, 36, 0.10);
          }

          .onlineDealBtn {
            flex: 1 1 auto;
            height: 52px;
            background: var(--primary, #FF7A1A);
            border-radius: 4px;
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 52px;
            text-align: center;
            cursor: pointer;
            box-shadow: 0 10px 20px rgba(255, 122, 26, 0.20);
            transition: background-color 0.2s ease, box-shadow 0.2s ease;
          }

          .onlineDealBtn:hover {
            background: var(--primary-hover, #F97316);
            box-shadow: 0 12px 24px rgba(255, 122, 26, 0.24);
          }

          .DIBG_buyNum {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            margin: 0;
            .el-input-number {
              width: 128px;
              line-height: 34px;
            }
            .el-input__inner {
              height: 34px;
              padding: 0 34px;
              border: 1px solid var(--border-soft, #E8E4DE) !important;
              color: var(--text-main, #111827);
            }
            .el-input-number__decrease, .el-input-number__increase {
              width: 32px;
              height: 32px;
              border-color: var(--border-soft, #E8E4DE) !important;
              background: var(--bg-section, #F7F5F2) !important;
              color: var(--text-secondary, #5A5F6B) !important;
              transition: color 0.2s ease, background-color 0.2s ease;
            }
            .el-input-number__decrease:hover, .el-input-number__increase:hover {
              color: var(--brand-blue, #1A1D24) !important;
              background: var(--brand-blue-light, #F0EDE8) !important;
            }
          }
        }
      }
    }

    .DI_productName {
      display: block;
      margin: 0;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      overflow: hidden;

      /deep/.DI-productName {
        box-sizing: border-box;
        width: 100%;
        min-height: 124px;
        padding: 22px 24px;
        background: #FFFFFF;

        .DI_productName_title {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #111827);
          line-height: 28px;
          margin: 0 0 12px;

          img {
            width: 4px;
            height: 18px;
            margin: 0 10px 0 0;
            object-fit: cover;
            border-radius: 4px;
          }
        }

        .DI_productName_text {
          min-height: 44px;
          font-size: 15px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 24px;
          word-break: break-all;
        }
      }
    }

    .DI_links {
      width: 1120px;
      height: 40px;
      background: #FFFFFF;
      padding: 20px 40px;
      margin: 0 0 10px 0;

      .labels {
        display: flex;
        flex-direction: row;

        a {
          flex: 1;
          text-align: center;
          margin: 0 11px 0 0;
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 300;
          color: var(--text-secondary, #5A5F6B);
          padding: 11px 10px;
          border-radius: 4px;
          border: 1px solid var(--border-soft, #E8E4DE);
        }

        a:last-of-type {
          margin: 0;
        }

        a:hover {
          color: var(--primary, #FF5A1F);
          background: var(--bg-tag, #F0EDE8);
          border: 1px solid var(--bg-tag, #F0EDE8);
        }
      }
    }

    .details_tabbar {
      margin: 0;
      overflow: hidden;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

      /deep/ .el-tabs__content {
        padding: 24px;
      }

      .Tip {
        position: relative;

        .JL_tip {

        }

        .JL_tipBtn {
          position: absolute;
          bottom: 90px;
          right: 200px;
          cursor: pointer;
          background: none;
        }

        .JL_tipBtn:hover {
          animation: header_fourMove 0.2s linear infinite; // 重点，定义动画
          animation-fill-mode: forwards;
          animation-iteration-count: 1;
          @keyframes header_fourMove {
            0% {
              transform: translateY(0);
            }
            100% {
              transform: translateY(-2px);
            }
          }
        }
      }

      .first_content {
        width: 1120px;
        margin-bottom: 9px;
      }

      .second_content {
        width: 1120px;
        margin-bottom: 9px;
      }

      .third_content {
        min-height: 220px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: var(--text-main, #111827);
        font-size: 15px;
        line-height: 24px;

        img {
          display: block;
          max-width: 100%;
          object-fit: contain;
        }

        .third_content_item {
          margin-bottom: 50px;

          .content_item_title {
            display: flex;
            flex-direction: row;
            margin-bottom: 21px;

            div:first-of-type {
              margin-right: 20px;
            }

            div:last-of-type {
              font-size: 20px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #FF9407;
            }
          }

          .content_item_content {
            font-size: 16px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: #000000;
            line-height: 25px;

            img {
              width: 1120px;
              height: 128px;
              object-fit: cover;
            }
          }
        }

        .third_content_item:last-of-type {
          margin-bottom: 0;
        }

        .third_content_item:first-of-type {
          margin-bottom: 41px;
        }
      }

      .fourth_content {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;

        .fourth_content_item {
          width: calc((100% - 16px) / 2);

          .fourth_content_item_box {
            min-height: 86px;
            box-sizing: border-box;
            padding: 16px;
            display: flex;
            align-items: center;
            gap: 12px;
            margin: 0;
            background: var(--bg-section, #F7F5F2);
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:hover {
              border-color: rgba(26, 29, 36, 0.30);
              box-shadow: 0 8px 18px rgba(26, 29, 36, 0.08);
            }

            div:first-of-type {
              flex: 0 0 auto;
              margin-right: 0;

              img {
                width: 28px;
                height: 28px;
                object-fit: contain;
              }
            }

            .qq_logo {
              flex: 0 0 auto;
              margin-right: 0;

              img {
                width: 32px;
                height: 32px;
                object-fit: contain;
              }
            }

            .group_name {
              min-width: 0;
              flex: 1 1 auto;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 15px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-main, #111827);
              line-height: 22px;
              margin-right: 0;
            }

            .add_group {
              flex: 0 0 auto;
              width: 92px;
              height: 34px;
              background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
              border-radius: 4px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 34px;
              text-align: center;
              transition: box-shadow 0.2s ease;
            }

            .add_group:hover {
              box-shadow: 0 8px 18px rgba(26, 29, 36, 0.20);
            }
          }
        }
      }

      .groupEmpty {
        min-height: 220px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--bg-section, #F7F5F2);
        border: 1px dashed var(--border-soft, #E8E4DE);
        border-radius: 4px;
      }
    }
  }

  .showFalse {
    width: 300px;
    //height: 285px;
    background: #FFFFFF;
    padding: 50px 450px 70px;

    .showFalse_tip {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 0 39px 0;

      img {
        width: 229px;
        height: 150px;
        object-fit: cover;
        //margin: 0 0 6px 0;
      }

      #tip {
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: #9A9A9A;
        line-height: 20px;
      }
    }

    .showFalse_btnG {
      display: flex;
      flex-direction: column;
      align-items: center;

      a {
        width: 300px;
        height: 50px;
        border-radius: 4px;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: var(--text-main, #1A1D24);
      }

      #back {
        margin: 0 0 8px 0;
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        box-shadow: 0 10px 20px rgba(255, 90, 31, 0.22);
      }

      #back:hover {
        background: var(--primary-hover, #E84A12);
      }

      #cusSer {
        border: 1px solid var(--border-soft, #E8E4DE);
      }
    }
  }

}

@media screen and (max-width: 1360px) {
  .game_details {
    justify-content: flex-end;
    padding-right: 120px;

    .game_details_inner {
      width: calc(100vw - 160px);
      max-width: 1200px;
    }
  }
}

</style>
